<app-informate-sub-header [headerData]="subHeaderData" [calcOutput]="calculationResult"></app-informate-sub-header>
<div class="row" style="margin: 0 auto">
    <div class="col-lg-3 pb-7">
        <div cssClass="gutter-b card-stretch">
            <div class="card card-custom" [ngClass]="cssClass">
                <div class="card-header border-0 card-mobile-text pd-left-right-15" *ngIf="isInitialFormLoad">
                    <h3 class="card-title font-weight-bolder text-dark mt-8 mb-5 font-size-20">
                        <!-- Start a new Custom Flange Calculation -->
                            {{ 'STANDARD_FLANGE_PAGE.LABELS.START_NEW' | transloco }}
                    </h3>

                    <div class="divFullwidth">
                        <a href="javascript:void(0)" class="btn primary-ebtn font-weight-bold py-3 px-6 w-100"
                            (click)="beginform()" #beginbtn>
                            <!-- Save inputs as default -->
                            {{ 'STANDARD_FLANGE_PAGE.BUTTONS_TEXT.BEGIN' | transloco }}
                        </a>
                    </div>
                </div>

                <div class="card-body p-2 informate-expansion-wrapper">
                    <mat-expansion-panel #panel1 [disabled]="true" [expanded]="tighteningform" hideToggle>
                        <mat-expansion-panel-header (click)="showPanel1()">
                            <mat-panel-title>
                                <!-- Controlled Tightening Procedure -->
                                {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.CONTROL_TIGHTENING_PROCEDURE' | transloco }}
                                <a href="javascript:void(0)" *ngIf="editpanel_1" class="edit_icon"
                                    (click)="showPanel1()" #tooltip="matTooltip" matTooltip="Edit"
                                    [matTooltipPosition]="tooltip_position">
                                    <i class="flaticon2-pen"></i>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <app-tightening-procedure-input [isRedirect]="isRedirect"
                            [isInitialFormLoad]="isInitialFormLoad" (returnData)="tighteningDataHandler($event)"
                            (diagram)="diagramDataHandler($event)"></app-tightening-procedure-input>
                    </mat-expansion-panel>

                    <mat-expansion-panel #panel2 [disabled]="true" [expanded]="customForm" hideToggle>
                        <mat-expansion-panel-header (click)="showPanel2()">
                            <mat-panel-title>
                                <!-- Custom Flange -->
                                {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.CUSTOM_FLANGE' | transloco }}
                                <a href="javascript:void(0)" *ngIf="editpanel_2" class="edit_icon"
                                    (click)="showPanel2()" #tooltip="matTooltip" matTooltip="Edit"
                                    [matTooltipPosition]="tooltip_position">
                                    <i class="flaticon2-pen"></i>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <app-custom-flange-input [isRedirect]="isRedirect"
                            (returnData)="customFlangeDataHandler($event)"
                            (diagram)="diagramDataHandler($event)"></app-custom-flange-input>
                    </mat-expansion-panel>

                    <mat-expansion-panel #panel3 [disabled]="true" [expanded]="processform" hideToggle>
                        <mat-expansion-panel-header (click)="showPanel3()">
                            <mat-panel-title>
                                <!-- Process Information -->
                                {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.PROCESS_INFORMATION' | transloco }}
                                <a href="javascript:void(0)" *ngIf="editpanel_3" class="edit_icon"
                                    (click)="showPanel3()" #tooltip="matTooltip" matTooltip="Edit"
                                    [matTooltipPosition]="tooltip_position">
                                    <i class="flaticon2-pen"></i>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <app-process-information-input [isRedirect]="isRedirect"
                            (returnData)="processInfoDataHandler($event)"></app-process-information-input>
                    </mat-expansion-panel>

                    <mat-expansion-panel #panel4 [disabled]="true" [expanded]="toolsform" hideToggle>
                        <mat-expansion-panel-header (click)="showPanel4()">
                            <mat-panel-title>
                                <!-- Tool Selection -->
                                {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.TOOL_SELECTION' | transloco }}
                                <a href="javascript:void(0)" *ngIf="editpanel_4" class="edit_icon"
                                    (click)="showPanel4()" #tooltip="matTooltip" matTooltip="Edit"
                                    [matTooltipPosition]="tooltip_position">
                                    <i class="flaticon2-pen"></i>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <app-tools-input [isRedirect]="isRedirect" [tools]="toolsData"
                            (nearestObst)="toolsDataHandler($event)" (selectedTool)="selectedToolDataHandler($event)"
                            (diagram)="diagramDataHandler($event)"></app-tools-input>
                    </mat-expansion-panel>

                    <!-- <br /> -->
                    <div class="calculation_btn">
                        <button class="btn primary-ebtn py-3 px-6 w-100" [disabled]="
                                !isTighFormValid ||
                                !isCustomFormValid ||
                                !isProcessFormValid ||
                                customInputForm?.invalid ||
                                processInfoForm?.invalid ||
                                tighteningProcedureForm?.invalid ||
                                toolsFormGroup?.invalid ||
                                isInputValid == false
                            " (click)="btnCalculateClicked()">
                            <!-- Calculate -->
                            {{ 'STANDARD_FLANGE_PAGE.BUTTONS_TEXT.CALCULATE' | transloco }}
                        </button>
                    </div>
                    <!-- <br /> -->
                </div>
                <!--end: Card Body-->
            </div>
        </div>
    </div>
    <div class="col-lg-9">
        <div class="card card-custom gutter-b card-stretch">
            <div class="card-body">
                <mat-tab-group class="tab-wrapper" [(selectedIndex)]="outputTabIndex">
                    <!-- <mat-tab label="Diagrams"> -->
                    <mat-tab label="{{ 'STANDARD_FLANGE_PAGE.LABELS.DIAGRAMS' | transloco }}">
                        <div class="card-body custom-wrapper row section-scroll height-800"
                            style="width: 100%; display: table">
                            <app-diagrams [isRedirect]="isRedirect" [diagramInfo]="diagramInfo"
                                [calcOutput]="calculationResult" (diagram)="diagramDataHandler($event)"
                                (CalcOverrides)="diagramControlDataHandler($event)"
                                (DiagramFormData)="DiagramFormDataHandler($event)"></app-diagrams>
                        </div>
                    </mat-tab>
                    <!-- <mat-tab label="Calculation Outputs"> -->
                    <mat-tab label="{{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_OUTPUT' | transloco }}">
                        <div class="card-body custom-wrapper row section-scroll height-800" style="width: 100%">
                            <app-warning-output class="col-md-12" [calcOutput]="calculationResult"></app-warning-output>
                            <div class="col-xl-6 col-lg-12" *ngIf="calculationResult?.calculationSucceeded">
                                <app-calculation-output [calcOutput]="calculationResult" [selectedTool]="selectedTool"
                                    style="width: 100%" (showAdvOptPanel)="showpanel()"
                                    *ngIf="calculationResult"></app-calculation-output>
                            </div>
                            <div class="col-xl-6 col-lg-12">
                                <app-stress-factors-output [calcOutput]="calculationResult"
                                    *ngIf="calculationResult?.calculationSucceeded && diagramInfo"
                                    [diagramInfo]="diagramInfo" style="width: 100%"></app-stress-factors-output>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</div>

<div class="output-wrapper">
    <div *ngIf="hideAdvanceOptionTab == true">
        <div class="output-advance-option">
            <a href="javascript:void(0)" (click)="showpanel()">
                <p>
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                    <!-- Advance outputs -->
                    {{ 'ADVANCED_OUTPUT.LABELS.ADVANCED_OUTPUT' | transloco }}
                </p>
            </a>
        </div>
        <app-advanced-output [showpaneltoggle]="showpaneltoggle" [calcOutput]="calculationResult"
            (hidepanel)="hidepanelclose()"></app-advanced-output>
    </div>

    <div>
        <div class="output-unit">
            <a href="javascript:void(0)" (click)="showUnitpanel()">
                <p>
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                    <!-- Advance outputs -->
                    Units
                </p>
            </a>
        </div>
        <app-units [showPanelUnitToggle]="showPanelUnitToggle" (hideUnitpanel)="hideUnitpanelClose()"></app-units>
    </div>
</div>